import React from 'react';
import hasValidationErrors from 'components/connectedForm/utils/hasValidationErrors';
import { createBackgroundProcess } from 'utils/BackgroundJobs';
import PurchaseOpeningBalancePostMutation from 'graphql/mutations/supplier/PurchaseOpeningBalancePostMutation.graphql';
import { PostSelectButton } from '../../components/SelectButton';
import getClientMutationId from '../../utils/getClientMutationId';

export const formActions = [
  {
    description: 'Post Opening Balances',
    component: PostSelectButton,
    fn: postOpeningBalance,
    individualButton: true,
    performSave: true,
    saveMessage: 'Opening balances posted',
    condition: canBePosted,
  },
];

function canBePosted(openingBalance) {
  if (openingBalance && openingBalance.documentStatus) {
    return openingBalance.documentStatus === 'DRAFT';
  }
  return false;
}

function postOpeningBalance(props) {
  const { values, connectedForm } = props;
  if (hasValidationErrors(connectedForm)) return;
  const input = {
    clientMutationId: getClientMutationId(),
    id: values.id,
  };
  createBackgroundProcess(PurchaseOpeningBalancePostMutation, input, props, 'back', 'Post Opening Balance');
}
